import {Injectable} from '@angular/core';
import { ResetpassForm } from './resetpass';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { setting } from '../../../../setting';

@Injectable()

export class ResetpassService {
	public apiBookingUrl:string;

	constructor(private _http:HttpClient){
		 this.apiBookingUrl = setting.apiBookingUrl;
	}

	resetpass(recover: ResetpassForm){
		let json = JSON.stringify(recover);
		let headers = new HttpHeaders();
		headers.append('Content-Type','application/json');
		return this._http.post(this.apiBookingUrl+'forgotAccess', json, {headers: headers});
	}

}
